import type { SVGProps } from 'react';

import { Icon } from './Icon';

export function ScaleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon viewBox="0 0 28 28" {...props}>
      <path d="M14.0001 15.9743L1.76147 9.44564L14.0001 2.91669L26.2501 9.44564L14.0001 15.9743ZM14.0001 20.5287L2.43231 14.3681L4.26514 13.3627L14.0001 18.5366L23.7461 13.3627L25.5793 14.3681L14.0001 20.5287ZM14.0001 25.0834L2.43231 18.9225L4.26514 17.9174L14.0001 23.091L23.7461 17.9174L25.5793 18.9225L14.0001 25.0834ZM14.0001 13.9822L22.6019 9.44564L14.0001 4.90906L5.40935 9.44564L14.0001 13.9822Z" />
    </Icon>
  );
}
